import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [state, setState] = useState({ loading: true, ok: false, error: "" });

  useEffect(() => {
    const run = async () => {
      if (!token) {
        setState({ loading: false, ok: false, error: "Token manquant." });
        return;
      }
      try {
        await api.get(`/auth/verify?token=${encodeURIComponent(token)}`);
        setState({ loading: false, ok: true, error: "" });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Vérification impossible (token invalide ou expiré).";
        setState({ loading: false, ok: false, error: msg });
      }
    };
    run();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#1d191a] text-white flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white/5 border border-white/10 rounded-2xl p-6">
        <h1 className="text-xl font-semibold">Vérification email</h1>

        <div className="mt-3 text-sm text-white/80">
          {state.loading && <p>Vérification en cours…</p>}
          {!state.loading && state.ok && <p>✅ Email vérifié. Tu peux revenir sur la carte.</p>}
          {!state.loading && !state.ok && <p>❌ {state.error}</p>}
        </div>

        <div className="mt-6">
          <Link
            to="/"
            className="inline-block bg-amber-500 hover:bg-amber-600 text-black px-4 py-2 rounded-xl"
          >
            Revenir à UrbSex
          </Link>
        </div>
      </div>
    </div>
  );
}